import { api } from './api'

export interface MetricUsage {
  used: number
  limit: number
  remaining?: number | null
}

export interface UserUsageV2 {
  plan_id?: string
  plan_name?: string
  period_start: string
  period_end: string
  messages: MetricUsage
  chatbots: MetricUsage
  team_members: MetricUsage
}

export const getUserUsageV2 = async (): Promise<UserUsageV2> => {
  const res = await api.get<UserUsageV2>('/user/usage/')
  return res.data
}

export interface BudgetStatus {
  billing_mode: string
  ai_cost_usd: number
  training_cost_usd: number
  total_cost_usd: number
  ai_budget_usd: number
  budget_remaining_usd: number
  budget_used_percent: number
  messages_used: number
  messages_limit: number
}

export const getBudgetStatus = async (): Promise<BudgetStatus> => {
  const res = await api.get<BudgetStatus>('/user-analytics/budget')
  return res.data
}

export const formatLimit = (limit: number) => {
  if (limit === -1) return 'Unlimited'
  if (limit >= 1000) return `${(limit/1000).toFixed(1)}K`
  return `${limit}`
}

export const formatDollar = (amount: number) => {
  if (amount >= 1) return `$${amount.toFixed(2)}`
  if (amount > 0) return `$${amount.toFixed(3)}`
  return '$0.00'
}

